// extracted by mini-css-extract-plugin
module.exports = {"root":"Loaf-module__root___dV3ju Fonts-module__mt___2w9Sq"};